export default __webpack_public_path__ + "static/media/huk.1e4c8690.svg";